export default __webpack_public_path__ + "static/media/H1018.3.4bcca4d9.mp3";